import { render, staticRenderFns } from "./RakamDetay.vue?vue&type=template&id=640df924&scoped=true&"
import script from "./RakamDetay.vue?vue&type=script&lang=js&"
export * from "./RakamDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640df924",
  null
  
)

export default component.exports